import { Box, Link, Text } from "@simplybusiness/mobius";
import { useSnowplowContext } from "@simplybusiness/services";
import type { Quote } from "../../QuoteCards/types";
import { Logo } from "../QuoteCard/Logo";

type Insurer = {
  insurerName: string;
  insurerLogo: string;
};

type NoQuotesReferralProps = {
  quotes: Quote[] | null | undefined;
  referenceNumber?: string;
  contactPhoneNumber?: string;
  customerName?: string;
  coverOptionsUrl?: string;
};

export function NoQuotesReferral({
  quotes,
  referenceNumber,
  contactPhoneNumber,
  customerName,
  coverOptionsUrl,
}: NoQuotesReferralProps) {
  const insurersPanel: Insurer[] = (quotes || []).map(quote => ({
    insurerName: quote.insurerNameParametrized,
    insurerLogo: quote.insurerLogo,
  }));
  const { snowplow } = useSnowplowContext();
  const handleCoverOptionsClick = () =>
    snowplow?.trigger("coverOptionsLinkClicked");
  const handlePhoneNumberClick = () =>
    snowplow?.trigger("phoneNumberLinkClicked");

  return (
    <Box className="no-quotes-referral__container">
      <Text>
        Hi <strong>{customerName}</strong>, we&apos;ve searched through our
        panel of trusted providers but we havent been able to find results to
        match your cover detail selections. You can expand your search by
        editing your choices on the{" "}
        <Link href={coverOptionsUrl} onClick={handleCoverOptionsClick}>
          Cover Options
        </Link>{" "}
        page or through the filters above.
      </Text>
      <Box className="no-quotes-referral__insurer-panel">
        {insurersPanel.map((insurer, index) => (
          <Logo
            key={index}
            logoPath={insurer.insurerLogo}
            alt={insurer.insurerName}
            className="no-quotes-referral-logo"
          />
        ))}
      </Box>
      <Text className="no-quotes-referral__summary">
        If you prefer to speak with us, our team will give you a call to see if
        we can find a quote that is right for your business. If you&rsquo;d
        prefer to call us, we&apos;re here to help on{" "}
        <Link
          href={`tel:${contactPhoneNumber}`}
          onClick={handlePhoneNumberClick}
        >
          {contactPhoneNumber}
        </Link>{" "}
        and give us your reference number <strong>{referenceNumber}</strong>
      </Text>
    </Box>
  );
}
